import { render, staticRenderFns } from "./OrganizationAbout.vue?vue&type=template&id=b1ba798a&scoped=true"
import script from "./OrganizationAbout.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationAbout.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OrganizationAbout.vue?vue&type=style&index=0&id=b1ba798a&prod&lang=scss&scoped=true"
import style1 from "./OrganizationAbout.vue?vue&type=style&index=1&id=b1ba798a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ba798a",
  null
  
)

export default component.exports